export { default, type IllustrationDefinition } from './IllustrationRenderer';
